import { ELanguages } from "i18n/constants";

import i18n from "../../i18n";

export const formatRiskModel = (value: number): string => {
  const currentLanguage = i18n.language;
  const stringValue = value.toString();
  return stringValue.replace('.', currentLanguage === ELanguages.ruRU ? ',' : '.');
};